import ClientsAxios from "../../client-axios";
import { ExpenseTypeCreateRequest, ExpenseTypeListRequest } from "../../dto/request/master/expenseTypeMaster.type";
import { ResponseEntity } from "../../dto/response";

const { API_SERVER } = ClientsAxios;

export const FetchExpenseTypeListService = async (payload: ExpenseTypeListRequest | {}) => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.post('expense-type-master/list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}

export const CreateExpenseTypeService = async (payload: ExpenseTypeCreateRequest, isUpdate: boolean = false) => {

    const responseEntity = new ResponseEntity<{message: string}>();
    try {
        const urlType = isUpdate ? 'update' : 'store';
        const response = await API_SERVER.post(`expense-type-master/${urlType}`, payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}

export const DeleteExpenseTypeService = async (payload: { id: number }) => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.post('expense-type-master/delete', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}